import SortNumAsc from './SortNumAsc'

export default SortNumAsc
// eslint-disable-next-line import/export
export * from './SortNumAsc'
